import React, { useState } from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import store from "@utils/redux/store";
import initializeApplication from "@utils/initialization";
import { trackEvent } from "@utils/api/tracker";

import "./styles/global.less";
import { MultiRouterHack } from "./hooks/historyHack";
import { getRouterComponents } from "./router";
import { useOnce } from "./hooks/once";
import getRedirects from "./redirects";

const App = () => {
  const [appInitialized, setAppInitialized] = useState(false);

  useOnce(() => {
    const init = async () => {
      await initializeApplication();

      // Finally allow application to render.
      setAppInitialized(true);

      // After user being on the buyflow for at least 30 seconds, trigger mixpanel tracking for GoodClick
      setTimeout(() => {
        trackEvent("GoodClick");
      }, 30000);
    };
    init();
  });

  return (
    <BrowserRouter>
      <MultiRouterHack />

      <ReduxProvider store={store}>
        <Switch>
          {
            // Note that we need to do the concat here vs. treating redirect and router components as
            // their own components as Switch needs the elements to be direct children.
            getRedirects().concat(appInitialized ? getRouterComponents() : [])
          }
        </Switch>
      </ReduxProvider>
    </BrowserRouter>
  );
};

export default App;
